import React, { CSSProperties, MouseEvent, useContext } from 'react';

import { IconButton, ListItemIcon, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';
import { MapContext } from 'features/map/MapContext';
import { fitBoundsToBbox } from 'features/map/utils/mapUtils';
import { Geometry } from 'geojson';

interface IZoomToRoute {
  geometry: Geometry;
  onClose?: (e?: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  size?: string;
  sx?: CSSProperties;
}
export default function ZoomToRoute({
  geometry,
  onClose,
  className,
  size = '16px',
  sx = {},
}: IZoomToRoute) {
  const { refMap, mapReady } = useContext(MapContext);

  const handleZoomToRoute = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (refMap.current && mapReady && geometry)
      fitBoundsToBbox(refMap.current, geometry, 0.33);
    onClose?.();
  };
  if (onClose)
    return (
      <MenuItem onClick={handleZoomToRoute} className={className || ''}>
        <ListItemIcon aria-label="zoom" title="Zoom">
          <FontAwesomeIcon name="magnifying-glass-location" size="0.75rem" />
        </ListItemIcon>
        <Typography variant="caption">Zoom to Route</Typography>
      </MenuItem>
    );
  else
    return (
      <IconButton sx={sx} size="small" title="Zoom" onClick={handleZoomToRoute}>
        <FontAwesomeIcon name="magnifying-glass-location" size={size} />
      </IconButton>
    );
}
